var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: { height: _vm.containerHeight } }, [
    _c(
      "div",
      {
        ref: "canvasContainer",
        staticClass: "time-s-class",
        staticStyle: { height: "calc(100% - 50px)" },
        style: { margin: _vm.timeMargin + "px" },
      },
      [
        _c("canvas", {
          staticClass: "de-canvas",
          attrs: {
            id: "simple-canvas" + _vm.element.id,
            width: _vm.canvas_width,
            height: _vm.canvas_height,
          },
        }),
      ]
    ),
    _c(
      "div",
      {
        staticStyle: {
          height: "50px",
          display: "flex",
          "align-items": "center",
        },
      },
      [
        _c("p", {
          staticStyle: { width: "100%", margin: "auto" },
          style: {
            fontSize: parseInt(_vm.element.style.fontSize) * 1 + "px",
            color: _vm.element.style.color,
          },
          attrs: { id: _vm.element.id + "_fulltime" },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }